<template>
  <v-app id="inspire">
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import * as AppEvents from "@/events/app";

export default {
  name: "AuthLayout",
  methods: {
    onAppInitializeDone() {
      this.$router.push({name: 'home'})
    }
  },
  created() {
    this.$bus.$on(AppEvents.APP_INITIALIZE_DONE, this.onAppInitializeDone)
  },
  beforeDestroy() {
    this.$bus.$off(AppEvents.APP_INITIALIZE_DONE, this.onAppInitializeDone)
  }
}
</script>